import { ReactNode } from 'react';

import { Modal } from 'react-bootstrap';

type LessonActionModalProps = {
  isOpen: boolean,
  title: string,
  text: ReactNode,
  button: string,
  variant?: 'primary' | 'danger',
  isLoading?: boolean,
  onClosed: () => void,
  onConfirm: () => void,
}

const LessonActionModal = ({
  isOpen,
  title,
  text,
  button,
  variant = 'primary',
  isLoading = false,
  onClosed,
  onConfirm,
}: LessonActionModalProps) => {
  return (
    <Modal
      size='sm'
      aria-labelledby='lesson-action-title'
      centered
      backdrop='static'
      keyboard={true}
      show={isOpen}
      onHide={() => onClosed()}
      dialogClassName='custom-modal mw-600px'
      className='bg-black bg-opacity-50'
    >
      <Modal.Header>
        <Modal.Title id='lesson-action-title' className='flex-root d-flex justify-content-center'>
          <h2 className='fd-uppercase'>{title}</h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='w-100'>
          <div className='pb-10 text-center fs-5 text-gray-800'>
            {text}
          </div>

          <div className='d-flex flex-row mb-5'>
            <button
              type='button'
              className='btn btn-lg fw-bold btn-secondary btn-active-light w-100 mb-5 mx-1'
              onClick={() => onClosed()}
            >
              Fechar
            </button>
            <button
              type='button'
              className={`btn btn-lg fw-bold w-100 mb-5 mx-1 ${variant === 'danger' ? 'btn-light-danger btn-active-danger' : 'btn-primary'}`}
              onClick={() => onConfirm()}
              disabled={isLoading}
            >
              {!isLoading && button}
              {isLoading && <span>
                Carregando... <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default LessonActionModal;
